import { makeAutoObservable } from 'mobx';
import { Message } from '@arco-design/web-react';
import {
  clearOperatorToken,
  setOperatorTokenToLocalStorage,
  setTokenToLocalStorage,
} from '@/utils/token';
import { makePersistable } from 'mobx-persist-store';
import User from './user';
import appStore from './app';
import { agentLogin, userLogin } from '@/api/modules/user';
import userStore from './user';
interface IUserInfo {
  /** 用户所属应用ID */
  aid: number;
  team_id: number;
  agent_id: number;
  avatar_color: string;
  created_at: number;
  last_login: number;
  last_login_ip: string;
  nickname: string;
  phone_number: string;
  updated_at: number;
  uuid: string;
  password_strength: number;
}
class Login_to {
  loading = false;
  token = null;
  user_info: IUserInfo;
  agent_id: number;

  request_id = {};
  uuid = {};
  isSuccess = false;
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'LoginStore',
      properties: ['uuid', 'user_info', 'agent_id'],
      storage: window.localStorage,
    });
  }

  /***
   * 修改状态
   */
  someMethod(data) {
    console.log('someMethod', data);

    const { token, user_info, info, request_id } = data;
    this.token = token;
    this.user_info = userStore.is_operator
      ? { ...info, nickname: info.nick_name }
      : user_info;
    if (userStore.is_operator) {
      userStore.setUserInfo(this.user_info);
    }
    this.request_id = request_id;
    this.uuid = user_info.uuid;
    if (user_info.aid >= 0) {
      appStore.setAid(user_info.aid || 0);
    }
  }

  setLoading(loading) {
    this.loading = loading;
  }

  /***
   * 登陆
   */
  async Accc_use_login(datalist) {
    return new Promise((resolve, reject) => {
      userLogin(datalist)
        .then((res) => {
          console.log(33333333333, res);

          if (res?.code == 0) {
            this.someMethod(res.data);
            setTokenToLocalStorage(res.data.token);
            clearOperatorToken();
            userStore.setOperatorLogin(false);
            userStore.setOperatorId(undefined);
            userStore.setCurrentTeam(null);
            userStore.clearAgentId();
            // this.isSuccess = true;
            //   this.team_id = res.data.team_id;
            //   User.getTeamInfo();
          } else {
            Message.info(res);
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async AgentLogin(datalist) {
    return new Promise((resolve, reject) => {
      const { aid, ...rest } = datalist;
      agentLogin(rest)
        .then((res) => {
          console.log('dataList==>', datalist);
          console.log(33333333333, res);

          if (res?.code == 0) {
            const isOperator = !!datalist.is_operator;
            userStore.setOperatorLogin(isOperator);
            this.someMethod(res.data);

            if (isOperator) {
              setOperatorTokenToLocalStorage(res.data.token);
              setTokenToLocalStorage(res.data.token);
              this.agent_id = null;
              userStore.clearAgentId();
              userStore.setOperatorId(
                res.data.operator_id ??
                  res.data.user_info?.operator_id ??
                  res.data.user_info?.id
              );
              userStore.setCurrentTeam(null);
            } else {
              clearOperatorToken();
              setTokenToLocalStorage(res.data.token);
              this.agent_id = res.data.user_info.agent_id;
              userStore.setAgentId(this.agent_id);
              userStore.setOperatorId(undefined);
              userStore.setCurrentTeam(null);
            }

            // this.isSuccess = true;
            //   this.team_id = res.data.team_id;
            //   User.getTeamInfo();
          } else {
            Message.info(res);
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  reset() {
    this.token = null;
    this.user_info = null;
    this.agent_id = null;
  }
}

const Login = new Login_to();
export default Login;
